import { useContext, useState } from 'react'
import { LuMoreVertical } from 'react-icons/lu'
import { Button, Popover, Popconfirm } from 'antd'
import Context from 'containers/UMS/Users/Context'
import useManageUSer from './useManageUser'
import authService from 'authService'

const Cell: React.FC<{ record: any }> = ({ record }) => {
  const isConsultant = authService.hasOnlyRoles(['CONSULTANTE'])
  const {
    states: { selectedUser, open },
    actions: { setSelectedUser, onOpen }
  } = useContext(Context)
  const [popOpen, setPopOpen] = useState(false)
  const { onClick, isLoading } = useManageUSer(setPopOpen)

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'end' }

  const props = {
    container: {
      style,
      onClick: e => {
        e.stopPropagation()
        setPopOpen(true)
      }
    },
    popover: {
      arrow: false,
      open: popOpen,
      destroyTooltipOnHide: true,
      placement: 'left' as 'left',
      trigger: 'click' as 'click',
      onOpenChange: val => !val && setPopOpen(false),
      content: (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li>
            <Button
              style={{ width: '100%', textAlign: 'start' }}
              type="text"
              onClick={e => {
                e.stopPropagation()
                setPopOpen(false)
                setSelectedUser(record.identity_uuid)
                onOpen('updateUser')
              }}
              disabled={isLoading || isConsultant}
            >
              Editar usuario
            </Button>
          </li>
          <li>
            <Button
              style={{ width: '100%', textAlign: 'start' }}
              type="text"
              disabled={isLoading}
              onClick={e => {
                e.stopPropagation()
                setPopOpen(false)
                setSelectedUser(record.identity_uuid)
                onOpen('userTransaction')
              }}
            >
              Transacciones del usuario
            </Button>
          </li>
          <li>
            <Button
              style={{ width: '100%', textAlign: 'start' }}
              type="text"
              disabled={isLoading || isConsultant}
              onClick={e => {
                e.stopPropagation()
                setPopOpen(false)
                setSelectedUser(record.identity_uuid)
                onOpen('userMerge')
              }}
            >
              Transferir cuenta
            </Button>
          </li>
          <li>
            <Popconfirm
              title="Bloquear usuario"
              description="¿Está seguro que desea bloquear este usuario?"
              onConfirm={() => onClick(record.identity_uuid, 'block')}
              okText="Bloquear"
              cancelText="Cancelar"
              okButtonProps={{
                danger: true
              }}
              placement="left"
            >
              <Button
                type="text"
                loading={isLoading}
                disabled={isConsultant}
                style={{ width: '100%', textAlign: 'start' }}
              >
                Bloquear usuario
              </Button>
            </Popconfirm>
          </li>
          <li>
            <Popconfirm
              title="Prohibir usuario"
              description="¿Está seguro que desea prohibir este usuario?"
              onConfirm={() => onClick(record.identity_uuid, 'ban')}
              okText="Prohibir"
              cancelText="Cancelar"
              okButtonProps={{
                danger: true
              }}
              placement="left"
            >
              <Button
                loading={isLoading}
                disabled={isConsultant}
                type="text"
                style={{ width: '100%', textAlign: 'start' }}
              >
                Prohibir usuario
              </Button>
            </Popconfirm>
          </li>
        </ul>
      )
    }
  }

  return (
    <div {...props.container}>
      <Popover {...props.popover}>
        <div style={style}>
          <LuMoreVertical style={{ cursor: 'pointer' }} />
        </div>
      </Popover>
    </div>
  )
}

const MoreOptions: React.FC = (id: string, record) => {
  if (id === '' || !id) return null

  return <Cell record={record} />
}

export default MoreOptions
